// extracted by mini-css-extract-plugin
export default {"header":"styles_header__4oUtI","logo":"styles_logo__ZEmUT","link":"styles_link__EUnfn","select":"styles_select__8AHh1","login":"styles_login__gXPLa"};